jQuery(function() {
    jQuery('.bm-Google-Map').click(function(e) {
        jQuery(this).find('iframe').css('pointer-events', 'all');
    }).mouseleave(function(e) {
        jQuery(this).find('iframe').css('pointer-events', 'none');
    });
})